<script>
	import { fade } from 'svelte/transition'
  import { cubicOut } from 'svelte/easing'
	import { dark_theme } from './../stores.js'

  export let on_fill = false
</script>

<h1 
  class:on_fill
  class:dark_theme={$dark_theme} 
  transition:fade="{{ duration: 250, easing: cubicOut }}">
  <slot/>
</h1>

<style>
  h1 {
    font-family: var(--PensumDisplay);
    font-size: 5.2rem;
    line-height: 6rem;
    letter-spacing: 0.05rem;
    color: var(--c-text);
  }
  h1.on_fill {
    color: var(--c-accent-teal);
  }
  h1.on_fill.dark_theme {
    color: var(--c-accent);
  }

  @media only screen and (max-width: 580px) {
    h1 {
      font-size: 4.2rem;
      line-height: 4.8rem;
    }
  }

  @media only screen and (min-width: 1360px) and (min-height: 800px){
    h1 {
      font-size: 6.2rem;
      line-height: 8rem;
    }
  }
</style>